import { render, staticRenderFns } from "./ReviewExerciseItem.vue?vue&type=template&id=4a5e4751"
import script from "./ReviewExerciseItem.vue?vue&type=script&lang=js"
export * from "./ReviewExerciseItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports